import { render, staticRenderFns } from "./PayrollMovementsTab.vue?vue&type=template&id=43da2e1f&scoped=true"
import script from "./PayrollMovementsTab.vue?vue&type=script&lang=js"
export * from "./PayrollMovementsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43da2e1f",
  null
  
)

export default component.exports